import {useState} from 'react';
import Name from './Name-Anim';

import '../css/Banner.css';

const Banner = () => {
    return (
        <div className='Banner'>
        <div className="banner-div">
            <div className="banner-data">
                <div className='job'>
                    <h3>Front End Developer</h3>
                </div>
                <div className='name'>
                    <Name/>
                </div>
                <div className='data'>
                    <p>I craft user interfaces using modern frontend web technologies.</p>
                </div>
                <div className='banner-icons'>
                    <a href="https://www.linkedin.com/in/arundhati-bandopadhyaya-519162191/"><img src={require("../assets/banner/linked-in_banner.png")} alt="linked-in"/></a>
                    <a href="https://dribbble.com/overReacting"><img src={require("../assets/banner/dribbble_banner.png")} alt="linked-in"/></a>
                    <a href="https://github.com/Arundhati1234"><img src={require("../assets/banner/github_banner.png")} alt="linked-in"/></a>
                    <a href="https://codepen.io/overReacting"><img src={require("../assets/banner/codepen_banner.png")} alt="linked-in"/></a>
                </div>
            </div>
            <div className="banner-img">
                <img src={require("../assets/banner/profile-img.png")} alt="profile"/>
            </div>
        </div>
        </div>
    );
}

export default Banner;
